import { Navigate, Outlet, useLocation } from 'react-router-dom';

import { useSession } from '@/lib/auth';

/**
 * Route-level auth gate.
 *
 * Usage in `src/routes/index.tsx`:
 *
 *   {
 *     element: <RequireAuth />,
 *     children: [
 *       { path: '/checkout', element: <Checkout /> },
 *       { path: '/my-tickets', element: <MyTickets /> },
 *     ],
 *   }
 *
 * Unauthenticated users get redirected to `/login?from=<pathname+search>`.
 * Login.tsx reads `from` and navigates back after sign-in.
 */
export function RequireAuth(): JSX.Element {
  const { session, loading } = useSession();
  const location = useLocation();

  if (loading) {
    return (
      <div className="container-fc py-12 text-fc-muted" role="status" aria-live="polite">
        Cargando…
      </div>
    );
  }

  if (!session) {
    const from = encodeURIComponent(location.pathname + location.search);
    return <Navigate to={`/login?from=${from}`} replace />;
  }

  return <Outlet />;
}
